import Cookies from 'js-cookie';

import { useDisclosure } from '@chakra-ui/react';

import { BrowBanner } from '~/components/brow-banner';
import { setClientCookie } from '~/features/cookies/utils/set-client-cookie';
import { publicEnv } from '~/features/environment/public';
import { getMaintenanceBannerState, MAINTENANCE_DISMISSAL_HOURS } from '~/features/maintenance/utils/get-banner-state';

/**
 * Site-wide maintenance banner driven by the `NEXT_PUBLIC_MAINTENANCE_MESSAGE`
 * environment variable. When the value is non-empty, the banner is rendered
 * with an info-style appearance and supports Markdown (links, bold, etc.).
 *
 * The banner is dismissable per-user; the dismissal is stored in a cookie
 * keyed by a hash of the message text and expires after 24 hours. Because the
 * cookie key is derived from the message, updating the env var to a new
 * message automatically re-shows the banner to users who dismissed the
 * previous one.
 */
export function MaintenanceBanner() {
  const { isVisible, dismissalCookieKey, message } = getMaintenanceBannerState(
    publicEnv.NEXT_PUBLIC_MAINTENANCE_MESSAGE,
    (key) => Cookies.get(key)
  );

  const { isOpen, onClose } = useDisclosure({
    defaultIsOpen: true,
    onClose: () => {
      if (!dismissalCookieKey) return;
      const expiresAt = new Date(Date.now() + MAINTENANCE_DISMISSAL_HOURS * 60 * 60 * 1000);
      setClientCookie(dismissalCookieKey, 'true', expiresAt);
    },
  });

  if (!isVisible) {
    return null;
  }

  return <BrowBanner isCloseable={true} open={isOpen} text={message} type='info' onClose={onClose} />;
}
